import { create } from 'zustand';
export const exampleGlowColors = [
    '#f2ebef',
    '#e6dcf2',
    '#f2ebef',
    '#f2ebef',
    '#e6dcf2',
    '#f2ebef',
];
const extractMainColor = (gradient) => {
    const match = gradient.match(/rgba?\([^)]+\)/);
    return match ? match[0] : 'rgba(0, 0, 0, 1)'; // Default fallback color
};
const useGradientStore = create((set) => ({
    duration: 0.8,
    ease: 'power1.out',
    mainColor: 'rgba(255, 255, 255, 1)',
    gradients: [],
    setGradients: (gradients, glowColor) => {
        const mainColor = gradients.length > 0
            ? extractMainColor(gradients[0])
            : 'rgba(0, 0, 0, 1)';
        set({ gradients, mainColor });
    },
}));
export default useGradientStore;
